<section class="container">
  <section class="job-ready-skills" [ngClass]="{'home': !isFrontEnd}">
      <h2>{{course.title}} <span>{{course.duration}}</span> μήνες</h2>
      <p>{{course.description}}</p>
  </section>
  <div  *ngIf="isFrontEnd" class="topic-btns">
    <app-learning-paths></app-learning-paths>
  </div>
</section>